import styled from 'styled-components';

import { ThemeProp } from '../../theme/Themes';
import Text from '../Text';

export const Container = styled.div`
  display: flex;

  flex-direction: row;
  justify-content: center;

  height: 40px;
  width: 80px;
  box-sizing: border-box;
  border-radius: 4px;
  padding: 0;
  cursor: pointer;
`;

interface UnitsContainerProps {
  $isLast?: boolean;
  $isActive?: boolean;
  $isOnlyOneOption?: boolean;
  $limitWidth?: boolean;
}

export const UnitContainer = styled.div<any>`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  margin: 0;
  border-radius: 0.5rem;
  z-index: ${(props: UnitsContainerProps) => (props.$isActive ? '2' : '1')};

  ${(props) =>
    props.$isLast
      ? `
      margin-left: -11px;
      padding: 10px 10.5px 10px ${props.$isActive ? '8px' : '16px'};`
      : `
      padding: 10px  ${props.$isActive ? '10px' : '13px'} 10px 8px;
      `}

  ${(props: UnitsContainerProps) => props.$isOnlyOneOption && `margin-left: 0px; padding: 10px 8px;`}
  flex: 1;
  background: ${(props: UnitsContainerProps & ThemeProp) =>
    props.$isActive ? props.theme.gradients.button.default : props.theme.colors.neutrals.c100};
`;

interface UnitTextProps {
  $isActive?: boolean;
}

export const UnitText = styled(Text)<UnitTextProps>`
  font-size: ${(props: ThemeProp) => props.theme.fontSize.s};
  color: ${(props: ThemeProp & UnitTextProps) =>
    props.$isActive ? props.theme.colors.layout.surface.default : props.theme.colors.neutrals.c500};
  font-weight: ${(props: ThemeProp) => props.theme.fontWeight.semibold};
  text-transform: capitalize;
`;
